import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Marker } from 'react-google-maps';

import BranchInfoBox from '../branch-info-box/BranchInfoBox';

import './BranchMarker.scss';

class BranchMarker extends Component {
    state = { isDescriptionOpen: true };

    constructor(props) {
        super(props);

        this.handleMarkerClick = this.handleMarkerClick.bind(this);
    }

    handleMarkerClick(event) {
        this.setState({ isDescriptionOpen: !this.state.isDescriptionOpen });
    }

    render() {
        const { restaurant, position } = this.props;

        return (
            <Marker position={position} onClick={this.handleMarkerClick}>
                {this.state.isDescriptionOpen &&
                    <BranchInfoBox restaurant={restaurant} turnOffDescription={this.handleMarkerClick}></BranchInfoBox>}
            </Marker>
        );
    }
}

BranchMarker.propTypes = {
    restaurant: PropTypes.object,
    position: PropTypes.object,
    
};

export default BranchMarker;
